<template>
  <div class="header">
    <div @click="reCreate" style="cursor: pointer">
      <img class="header__left--icon" src="@/assets/images/index/icon1.png" />
      <span class="header-name">学科网智能平台</span>
    </div>
    <div class="header__right--my">
      <span class="my-design" @click="myDesign">我的设计</span>
      <el-popover
        placement="top-start"
        width="100"
        @show="iconMaskVisible = true"
        @hide="iconMaskVisible = false"
        trigger="hover"
      >
        <span class="header__icon" slot="reference">
          <span class="mask" v-show="iconMaskVisible">...</span>
          <img :src="userInfo.face" alt="" />
        </span>
        <div class="loginOut">
          <div class="name">{{ userInfo.loginName }}</div>
          <div class="loginOut-btn" @click="loginOut">
            <i class="iconfont icon-quit"></i> 安全退出
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { LOGINOUTURL } from "@/assets/scripts/api";
import { mapMutations, mapState } from "vuex";
export default {
  name: "ai-header",
  data() {
    return {
      iconMaskVisible: false,
    };
  },
  computed: mapState(["scale", "userInfo"]),
  methods: {
    ...mapMutations(["updataScale"]),
    reCreate() {
      this.$router.replace("/");
    },
    myDesign() {
      let routePath = "/banner/list";
      if (/cover/.test(this.$route.path)) {
        routePath = "/cover/list";
      }
      if (/poster/.test(this.$route.path)) {
        routePath = "/poster/list";
      }
      this.$router.push(routePath);
    },
    loginOut() {
      window.location.href = LOGINOUTURL;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  height: 60px;
  padding: 13px 30px;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.06);
  background: rgba(33, 37, 49, 0.9);
  z-index: 9;
  .header__icon {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    width: 32px;
    height: 32px;
    margin-left: 20px;
    border-radius: 16px;
    border: 1px solid #d6dbe0;
    overflow: hidden;
    .mask {
      position: absolute;
      display: inline-block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 25px;
      line-height: 15px;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10;
      color: #fff;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header__left--msg {
    position: absolute;
    top: 18%;
    left: 13%;
  }
  .header__right--my {
    display: flex;
    justify-content: space-between;
    height: 33px;
    .my-design {
      width: 88px;
      height: 32px;
      border-radius: 32px;
      background: #624aff;
      border: 1px solid rgba(255, 255, 255, 0.05);
      color: #fff;
      text-align: center;
      font-size: 14px;
      line-height: 32px;
      cursor: pointer;
    }
  }
  .header__left--icon {
    margin-right: 15px;
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
  .header-name {
    font-size: 18px;
    background: linear-gradient(90deg, #26beff 0%, #624aff 51%, #9e57ff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.loginOut {
  text-align: center;
  .name {
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
  }
  .loginOut-btn {
    width: 100px;
    padding: 5px;
    margin: 0 auto;
    text-align: center;
    border-radius: 26px;
    font-weight: 500;
    color: #777;
    font-family: PingFangHK-Medium, PingFangHK;
    cursor: pointer;
    transition: all 0.2s;
    user-select: none;
    i {
      display: inline-block;
      transform: translateY(1px);
    }
    &:hover {
      color: #333;
    }
  }
}
</style>
